const websiteConfig = {
  basic: {
    // 官网基础信息
    activityId: 'dgslgyy',
    gameId: 322,
    gameCode: 'dgslgkr',
    title: '게임 오브 엠파이어-나만의 제국을 건설하라',
    description: '<게임 오브 엠파이어>는 높은 자유도의 전략 게임으로, 원하는 문명을 선택해 나만의 제국을 기초부터 차근차근 세워나갈 수 있습니다. 육지와 바다를 마음껏 탐험하며 문명의 불가사의를 쟁탈하고, 스테이지를 하나하나 통과하세요! 대륙을 하나로 통일하고 신비한 고대 아틀란티스로 향하는 원정의 대서사시를 써 보세요! ★자유로운 문명 선택 게임을 시작하면 다양한 문명들이 당신의 선택을 기다리고 있습니다. 각각의 문명에는 서로 다른 독특한 건축물이 있으며, 특수한 병종과 그에 따른 특별 보너스도 제공됩니다. 가장 마음에 드는 문명을 선택해 전설적 여정을 시작해 보세요! ★제국을 향한 착실한 발걸음 농민을 모집해 경지를 관리하고, 과학 연구로 문명을 한걸음 더 진보시키세요. 바바리안을 처치하고, 지도 위의 마을을 오가며 무역을 해 보세요. 병사를 훈련하고 비축하여 다음 전쟁에 단단히 대비하세요! 당신의 작은 나라를 부강한 제국으로 성장시키세요! ★다시 부활하는 역사의 전설 선덕여왕! 알렉산더 대왕! 잔다르크! 당신 곁에서 제국 건설을 든든하게 지원하고 새로운 전기를 함께 써내려갈 역사적 인물들을 모집하세요! 역사에 길이 남을 명전투 속으로 되돌아가 무장의 업적을 직접 체험하고 전장의 실제 전략을 결정하여 진정한 전쟁의 예술을 느껴보세요! ★실시간 전투와 짜릿한 승리 복잡하고 광활한 지도에서 실시간으로 군대를 지휘하고 전투하세요! 병종 상성을 이용해 적은 수의 병사로 대군을 무찌르세요! 전술을 연구하고 자욱한 안개를 이용하여 누구도 예상 못한 승리를 거두세요! 도시 공방전에 참가해 적군의 마지막 방어선을 무너뜨리세요! 평원과 산지, 설산과 바다, 어디든 당신의 목표가 될 수 있습니다! 육지의 불가사의를 쟁탈하고 해상 허브를 점거하세요. 겹겹의 장애물을 뚫고 마지막 보스를 쓰러뜨려 대륙의 제왕으로 우뚝 서세요! ★합종연횡 연맹 건설 맹우를 찾아 연맹을 세우고 함께 영토를 넓혀 보세요. 합종연횡의 노련한 외교술로 든든한 지원군을 확보하세요!',
    keywords: '제국 전쟁 전략 모바일 게임 4X 신성 로마 제국 잉글랜드 바이킹 문명 한국 RTS 기병 보병 궁병 농경 공성 공주 왕후 석기 시대 철기 시대 청동 시대 주민 해전 역사 알렉산더 대왕 사자왕 리처드 카이사르 선덕공주 성녀 잔 다르크',
  },
  // 官网模块内容及顺序
  section: [
    'index', // 首屏
    'thirdParty',
    'role',
    'special',
  ],
  menu: {
    list: [
      // 导航栏配置：
      // name:显示名称
      // type: scroll: 滚动、 routeName：切换路由、link：链接外跳
      // target: 滚动的dom选择器或跳转链接
      {
        name: '사전 예약 보상',
        type: 'scroll',
        target: '#index',
      },
      {
        name: '커뮤니티',
        type: 'scroll',
        target: '#thirdParty',
      },
      {
        name: '캐릭터',
        type: 'scroll',
        target: '#role',
      },
      {
        name: '게임 소개',
        type: 'scroll',
        target: '#special',
      },
    ],
    safeDistance: 70, // 滚动安全区，单位px
    thirdParty: {
      type: ' facebook',
      link: '',
      picUrl: '',
      shareUrl:
        'https://gevents.goeofficial.com/dgslgyy/index.html#/?cid=share&scid=fb',
      appId: 620307132730922,
      title: '',
      desc: '',
    },
    mobileThirdParty: [
      {
        type: 'facebook',
        link: 'https://www.facebook.com/gameofempiresofficial',
      },
      {
        type: 'discord',
        link: 'https://discord.gg/game-of-empires-933539735694094356',
      },
      {
        type: 'naver',
        link: 'https://game.naver.com/r/GM_NCR_008671',
      },
    ],
  },
  lang: {
    show: false, // 是否有多语言
    list: [
      //支持的语言选项
      {
        code: 'zh-TW',
        name: '繁体',
      },
      {
        code: 'en-US',
        name: '英文',
      },
      {
        code: 'ja-JP',
        name: '日语',
      },
      {
        code: 'th-TH',
        name: '泰语',
      },
      {
        code: 'ko-KR',
        name: '韩语',
      },
    ],
  },
  reserveLink: {
    appstore: 'https://goekr.onelink.me/5ScO/3kqj1pu6',
    googlePlay: 'https://goekr.onelink.me/5ScO/3kqj1pu6',
  },
  reserveInfo: {
    phoneCode: [],
    service: '//gpassport.goeofficial.com/center/ServicePrivicy/service',
    privacy: '//gpassport.goeofficial.com/center/ServicePrivicy/privicy',
  },
  index: {
    // 首屏相关配置
    videoLink: '',
    reserveList: [
      {
        name: '> 1단계 <',
        num: 15,
        pic: new URL(
          '@images/index/index_reserve_level_1.png',
          import.meta.url
        ),
      },
      {
        name: '> 2단계 <',
        num: 30,
        pic: new URL(
          '@images/index/index_reserve_level_2.png',
          import.meta.url
        ),
      },
      {
        name: '> 3단계 <',
        num: 45,
        pic: new URL(
          '@images/index/index_reserve_level_3.png',
          import.meta.url
        ),
      },
      {
        name: '> 4단계 <',
        num: 50,
        pic: new URL(
          '@images/index/index_reserve_level_4.png',
          import.meta.url
        ),
      },
      {
        name: '> 5단계 <',
        num: 60,
        pic: new URL(
          '@images/index/index_reserve_level_5.png',
          import.meta.url
        ),
      },
    ],
  },
  aside: {
    // 新闻资讯/文章列表配置
    link: 'https://game.naver.com/r/GM_NCR_008671',
  },
  thirdParty: {
    // 社群相关配置
    giftList: [
      // 奖励道具列表
    ],
    supportArr: [
      // 支持的社群列表
      {
        type: 'facebook',
        link: 'https://www.facebook.com/gameofempiresofficial',
        num: 9999,
      },
      {
        type: 'discord',
        link: 'https://discord.gg/game-of-empires-933539735694094356',
        num: 9999,
      },
      {
        type: 'naver',
        link: 'https://game.naver.com/r/GM_NCR_008671',
        num: 9999,
      },
    ],
  },
  role: {
    // 角色相关配置
    title: '', // 主标题
    desc: '', // 副标题
    list: [
      {
        name: '', // 主模块名称
        num: 5, // 模块包含轮播数
        mediaType: '', // 媒体类型：audio-音频，video-视频，若无则置空即可如''
        mediaArr: [], // 媒体资源路径，视频填写youtube链接，音频填写资源名称(mp3)。若无则保留空数组即可如[]
        roleInfo: [
          {
            name: '핫토리 한조',
            desc: '핫토리 한조의 본명은 핫토리 마사나리이며, 도쿠가와 십육신장 중 한 명이며 ‘귀신 한조’라 불리기도 했다.',
            cardPic: new URL('@images/role/role_card_1.png', import.meta.url),
            pic: new URL('@images/role/popup_role_1.png', import.meta.url),
            rolebg: new URL('@images/popup/popup_role_bg1.png', import.meta.url),
            skill: [
              {
                name: '엄청난 충심',
                pic: new URL(
                  '@images/role/popup_role_skill_1_1.png',
                  import.meta.url
                ),
              },
              {
                name: '회피 승마술',
                pic: new URL(
                  '@images/role/popup_role_skill_1_2.png',
                  import.meta.url
                ),
              },
              {
                name: '은밀한 암살',
                pic: new URL(
                  '@images/role/popup_role_skill_1_3.png',
                  import.meta.url
                ),
              },
              {
                name: '귀인',
                pic: new URL(
                  '@images/role/popup_role_skill_1_4.png',
                  import.meta.url
                ),
              },
              {
                name: '그림자 분신',
                pic: new URL(
                  '@images/role/popup_role_skill_1_5.png',
                  import.meta.url
                ),
              },
              {
                name: '맹독 단검',
                pic: new URL(
                  '@images/role/popup_role_skill_1_6.png',
                  import.meta.url
                ),
              },
              {
                name: '천주',
                pic: new URL(
                  '@images/role/popup_role_skill_1_7.png',
                  import.meta.url
                ),
              },
            ],
            video: '',
          },
          {
            name: '선덕여왕',
            desc: '선덕여왕, 이름은 김덕만으로, 진평왕의 장녀이자 신라의 제27대 왕이다(632년~647년 재위). 신라 최초의 여왕으로, 어질고 총명했다고 한다.',
            cardPic: new URL('@images/role/role_card_2.png', import.meta.url),
            pic: new URL('@images/role/popup_role_2.png', import.meta.url),
            rolebg: new URL('@images/popup/popup_role_bg2.png', import.meta.url),
            skill: [
              {
                name: '기민한 사고',
                pic: new URL(
                  '@images/role/popup_role_skill_2_1.png',
                  import.meta.url
                ),
              },
              {
                name: '통찰력',
                pic: new URL(
                  '@images/role/popup_role_skill_2_2.png',
                  import.meta.url
                ),
              },
              {
                name: '사면령',
                pic: new URL(
                  '@images/role/popup_role_skill_2_3.png',
                  import.meta.url
                ),
              },
              {
                name: '신라의 주인',
                pic: new URL(
                  '@images/role/popup_role_skill_2_4.png',
                  import.meta.url
                ),
              },
              {
                name: '조세 면제',
                pic: new URL(
                  '@images/role/popup_role_skill_2_5.png',
                  import.meta.url
                ),
              },
              {
                name: '사절 파견',
                pic: new URL(
                  '@images/role/popup_role_skill_2_6.png',
                  import.meta.url
                ),
              },
              {
                name: '자비심',
                pic: new URL(
                  '@images/role/popup_role_skill_2_7.png',
                  import.meta.url
                ),
              },
            ],
            video: '',
          },
          {
            name: '알렉산더 대왕',
            desc: '마케도니아의 알렉산더 3세는 알렉산더 대왕이라 불리며, 고대 그리스 마케도니아의 국왕이자, 고대 그리스의 유명 왕실 아지드 왕조의 일원이다. ',
            cardPic: new URL('@images/role/role_card_3.png', import.meta.url),
            pic: new URL('@images/role/popup_role_3.png', import.meta.url),
            rolebg: new URL('@images/popup/popup_role_bg3.png', import.meta.url),
            skill: [
              {
                name: '헤타이로이',
                pic: new URL(
                  '@images/role/popup_role_skill_3_1.png',
                  import.meta.url
                ),
              },
              {
                name: '고독한 싸움',
                pic: new URL(
                  '@images/role/popup_role_skill_3_2.png',
                  import.meta.url
                ),
              },
              {
                name: '모루 전술',
                pic: new URL(
                  '@images/role/popup_role_skill_3_3.png',
                  import.meta.url
                ),
              },
              {
                name: '쐐기진',
                pic: new URL(
                  '@images/role/popup_role_skill_3_4.png',
                  import.meta.url
                ),
              },
              {
                name: '에픽 원정',
                pic: new URL(
                  '@images/role/popup_role_skill_3_5.png',
                  import.meta.url
                ),
              },
              {
                name: '무적의 군대',
                pic: new URL(
                  '@images/role/popup_role_skill_3_6.png',
                  import.meta.url
                ),
              },
              {
                name: '신의 아들',
                pic: new URL(
                  '@images/role/popup_role_skill_3_7.png',
                  import.meta.url
                ),
              },
            ],
            video: '',
          },
          {
            name: '잔 다르크',
            desc: '성녀 잔 다르크는 프랑스의 군인이자 천주교의 성인이며 영국-프랑스 백년전쟁에서 활약한 프랑스의 민족 영웅이다.',
            cardPic: new URL('@images/role/role_card_4.png', import.meta.url),
            pic: new URL('@images/role/popup_role_4.png', import.meta.url),
            rolebg: new URL('@images/popup/popup_role_bg4.png', import.meta.url),
            skill: [
              {
                name: '성녀',
                pic: new URL(
                  '@images/role/popup_role_skill_4_1.png',
                  import.meta.url
                ),
              },
              {
                name: '신념',
                pic: new URL(
                  '@images/role/popup_role_skill_4_2.png',
                  import.meta.url
                ),
              },
              {
                name: '신성의 가호',
                pic: new URL(
                  '@images/role/popup_role_skill_4_3.png',
                  import.meta.url
                ),
              },
              {
                name: '구세주',
                pic: new URL(
                  '@images/role/popup_role_skill_4_4.png',
                  import.meta.url
                ),
              },
              {
                name: '오를레앙의 소녀',
                pic: new URL(
                  '@images/role/popup_role_skill_4_5.png',
                  import.meta.url
                ),
              },
              {
                name: '신의 계시',
                pic: new URL(
                  '@images/role/popup_role_skill_4_6.png',
                  import.meta.url
                ),
              },
              {
                name: '천사의 강림',
                pic: new URL(
                  '@images/role/popup_role_skill_4_7.png',
                  import.meta.url
                ),
              },
            ],
            video: '',
          },
          {
            name: '화목란',
            desc: '화목란은 중국 역사상 유명한 여장부이다. ',
            cardPic: new URL('@images/role/role_card_5.png', import.meta.url),
            pic: new URL('@images/role/popup_role_5.png', import.meta.url),
            rolebg: new URL('@images/popup/popup_role_bg5.png', import.meta.url),
            skill: [
              {
                name: '여장부',
                pic: new URL(
                  '@images/role/popup_role_skill_5_1.png',
                  import.meta.url
                ),
              },
              {
                name: '체부종군',
                pic: new URL(
                  '@images/role/popup_role_skill_5_2.png',
                  import.meta.url
                ),
              },
              {
                name: '나라 수호',
                pic: new URL(
                  '@images/role/popup_role_skill_5_3.png',
                  import.meta.url
                ),
              },
              {
                name: '남장여자',
                pic: new URL(
                  '@images/role/popup_role_skill_5_4.png',
                  import.meta.url
                ),
              },
              {
                name: '변경 토벌',
                pic: new URL(
                  '@images/role/popup_role_skill_5_5.png',
                  import.meta.url
                ),
              },
              {
                name: '효열 장군',
                pic: new URL(
                  '@images/role/popup_role_skill_5_6.png',
                  import.meta.url
                ),
              },
              {
                name: '기사무쌍',
                pic: new URL(
                  '@images/role/popup_role_skill_5_7.png',
                  import.meta.url
                ),
              },
            ],
            video: '',
          },
        ],
      },
    ], // 角色配置
  },
  clothes: {
    title: '名士风采', // 主标题
    desc: '读书之魂觉醒四方，无拘地图交互，无限自由飞索', // 副标题
    list: [
      {
        name: '嬴政',
        desc: '西楚昆仑盲剑客，美丽危险的赤练蛇',
      },
      {
        name: '王昭君',
        desc: '西楚昆仑盲剑客，美丽危险的赤练蛇',
      },
      {
        name: '西施',
        desc: '西楚昆仑盲剑客，美丽危险的赤练蛇',
      },
    ], // 角色配置
  },
  specialNum: 5,
  footer: {
    ageLimit: {
      show: false, // 是否展示年龄限制相关，若为false，可不填写对象内age及text内容
      age: '18', // -1:不展示  年龄分级：0 6 12 15 18
      text: [
        '*本遊戲內容涉及暴力（武俠動作）、角色穿著凸顯胸、臂之服飾',
        '*本遊戲部分內容需另行支付費用',
        '*請避免沉迷遊戲',
      ],
    },
    termArr: [
      // 包含条款 $HOST: 主域名
      {
        name: '서비스 이용약관',
        link: 'https://gpassport.$HOST/center/ServicePrivicy/service',
      },
      {
        name: '개인정보 처리방침',
        link: 'https://gpassport.$HOST/center/ServicePrivicy/privicy',
      },
    ],
  },
};
export default websiteConfig;
